"use client";

const styles = new Proxy({"KinervaContact":"KinervaContact-9d196","Title":"Title-9d196","FormBox":"FormBox-9d196"}, { get: (m, k) => (typeof k === "string" ? (m[k] ?? k) : m[k]) });
import { DEFAULT_FORM_HTML } from "./block";

interface KinervaContactProps {
  block: {
    title?: string;
    embedCode?: string;
  };
}

export default function KinervaContact({ block }: KinervaContactProps) {
  const { title = "Get In Touch", embedCode = DEFAULT_FORM_HTML } = block;

  return (
    <div className={styles.KinervaContact} id="GetInTouch">
      <h2 className={styles.Title}>{title}</h2>
      <div className={styles.FormBox}>
        {embedCode && (
          <div
            dangerouslySetInnerHTML={{ __html: embedCode }}
            suppressHydrationWarning
          />
        )}
      </div>
    </div>
  );
}
